import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Preguntas from './pages/Preguntas';
import PreguntasList from './pages/PreguntasList';
import InformacionLogistica from './pages/InformacionLogistica';
import Agenda from './pages/Agenda';
import NotFound from './pages/NotFound';

function isLoggedIn() {
  try {
    return !!localStorage.getItem('usuario');
  } catch {
    return false;
  }
}

function GuestOnly({ children }) {
  return isLoggedIn() ? <Navigate to="/" replace /> : children;
}

function AuthOnly({ children }) {
  return isLoggedIn() ? children : <Navigate to="/login" replace />;
}

function StaffOnly({ children }) {
  try {
    const stored = localStorage.getItem('usuario');
    const usuario = stored ? JSON.parse(stored) : null;
    if (!usuario?.es_staff) return <Navigate to="/" replace />;
    return children;
  } catch {
    return <Navigate to="/" replace />;
  }
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<GuestOnly><About /></GuestOnly>} />
          <Route path="login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="registro" element={<Registro />} />
          <Route path="preguntas" element={<AuthOnly><Preguntas /></AuthOnly>} />
          <Route path="admin/preguntas" element={<StaffOnly><PreguntasList /></StaffOnly>} />
          <Route path="informacion-logistica" element={<InformacionLogistica />} />
          <Route path="agenda" element={<AuthOnly><Agenda /></AuthOnly>} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
